import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ContactRequestButton from './components/ContactRequestButton'
import { cn } from '~/core/ui/utils'

const WhyDomainSection: FC = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-gray-100 my-[64px] desktop:mt-[140px] desktop:mb-0">
      <img
        src="/img/feature/lp/hero-background.png"
        alt="Background"
        className={cn(
          'absolute -top-10 left-12 size-[250px] object-cover rotate-[-35deg]',
          'tablet:left-0 tablet:size-[500px] tablet:right-[30%]'
        )}
      />
      <div
        className={cn(
          'tablet:h-[638px] !px-0',
          'flex flex-col gap-5 tablet:gap-0',
          'tablet:flex-row items-center'
        )}>
        <div className="px-4 flex flex-col w-full tablet:w-2/5 tablet:min-w-72 ml-[max(50vw-608px,16px)]">
          <img
            src="/img/feature/lp/talentsforce.svg"
            alt="talentsforce logo"
            className="size-16 tablet:size-[100px] mx-auto mt-16 tablet:mx-0"
          />
          <div className="text-center tablet:text-left text-[31px] leading-[36px] tablet:text-[37px] tablet:leading-[42px] text-gray-900 font-medium">
            {t('all_features:why_us')}
          </div>
          <div className="mt-3 table:mt-4 text-center tablet:text-left text-gray-700 text-base font-normal">
            {t('all_features:reason_of_us')}
          </div>
          <div className="mx-auto tablet:mx-0 mt-6 tablet:mt-4">
            <ContactRequestButton label={t('lp:talks_with_our_team')} />
          </div>
        </div>
        <div className="flex-1 h-full">
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="/img/feature/lp/why-us-desktop.png"
            />
            <source
              media="(max-width: 767px)"
              srcSet="/img/feature/lp/why-us-mweb.png"
            />
            <img
              alt="Why TalentsForce"
              className="h-full w-full object-contain"
            />
          </picture>
        </div>
      </div>
    </div>
  )
}

export default WhyDomainSection
